<template>
    <div class="container-fluid " style="padding-bottom: 50px;">
      <div class="row" style="padding-top:10px; background-color: #F3F4F7;">
        <div class="col-6" style="font-size: x-small; padding-bottom: 10px;">
<!--          <template v-if="item.registeredTitle != undefined && item.registeredTitle != null && item.registeredTitle.length > 0"><strong>{{item.registeredTitle}}</strong><br>trade as </template>-->
          <strong>{{item.title}}</strong><br>{{item.contact}}<br><span v-html="item.addressText"></span>
        </div>
        <div class="col-6 tnc-btn" style="font-size:  x-small; padding-bottom: 10px; vertical-align: center;">
          <span v-on:click="openTnc" style="font-weight: bold;">Terms & Conditions</span>
        </div>

      </div>
      <div class="row" v-if="item.webSetting !== undefined && item.webSetting !== null && item.webSetting.footerMessage !== null">
        <div class="col-12" v-html="item.webSetting.footerMessage"></div>
      </div>
      <div class="row" style="padding-top:10px;background: #F3F3F3; padding-bottom: 50px;">
        <div class="col-12" style="font-size:  x-small; margin-bottom: 10px;">
          Copyright @2020 <strong>{{item.title}}</strong>. All rights reserved
        </div>
        <div class="col-12" style="font-size:  x-small">
          Powered by <strong>Show Me The Menu</strong>
          <br>Borium Studio Limited
        </div>
        <div class="col-6" style="display: none;">
          <img style="height:25px;" src="https://storage.googleapis.com/menus-275719.appspot.com/logos/borium-logo-blue.png"/>
        </div>
      </div>
    </div>
</template>

<script>
    import EventBus from "../api/event-bus";

    export default {
        name: "Bottom",
      props: {
        item: {
          type: Object,
          default: function() {
            return{}
          }
        }
      },
      data() {
        return {
          isEemo:false,
        }
      },
      created() {
          // console.log("bottom item");
          // console.log(this.item);
          this.item.addressText = this.item.address.replace(/\n/g, '<br />');
          if(window.location.host === 'eemo.app') {
            this.$data.isEemo = true;
          }
      },
      mounted() {
      },
      methods: {
          openTnc: function() {
            EventBus.$emit("showTnCs", this.item);

          }

      }
    }
</script>

<style scoped>

  .no-tnc .tnc-btn {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue